/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-wrap-multilines */
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { DescriptionList, FoldOut, ProductInfo, ProductInfoSummary, ProductTable } from '@vwfs-bronson/bronson-react';
import { FinancialProductType } from '../../resources/base/models/enums';
import { formatPrice } from '../../services/common/format';
import { RootState } from '../../services/redux';
import { ShoppingCartModel } from './ShoppingCartModel';

const ShoppingCart: FunctionComponent<ShoppingCartModel> = ({ formData, dataStorageData, dataTheme }) => {
  const data = formData || dataStorageData;
  const { t } = useTranslation();

  const selectedFinancialProductData = useSelector((state: RootState) => state.custom.selectedFinancialProductData);

  if (Object.keys(dataStorageData).length === 0) {
    return null;
  }
  const customerData = data?.customerData;
  const vehicle = data?.vehicleData;
  const financialProduct = data?.financialProduct;
  const { calculation } = financialProduct;
  const vehicleImageUrl = '';
  const vehicleName = vehicle?.modelName
    ? `${vehicle?.modelName}`
    : `${vehicle?.model.description?.split(' ')[0]} ${vehicle?.model.name}`;
  const vehicleDescriptionLong =
    vehicle?.model.description || 'Benzine | 62kW (84 HP) | Manual Gear | Mojave Beige Metallic | Trendline';
  const Client =
    customerData?.partnerType === 'PRIVATE'
      ? `${customerData?.firstName} ${customerData?.lastName}`
      : customerData?.companyName;
  const transaction = data?.transaction;
  const { productType } = transaction;
  return null;
  // PC-2996 Shopping Cart switched off for the whole journey

  //   <FoldOut
  //     productInfoSummary={
  //       <ProductInfoSummary
  //         imgAlt="The product image"
  //         infoLabel={t('shoppingCart:infoLabel')}
  //         infoValue={formatPrice(financialProduct?.totalAmountInsAndServ || formatPrice(Number(857)))}
  //         title={vehicleName || 'VW Golf'}
  //         subtitle={vehicleDescriptionLong}
  //         imgSrc={vehicleImageUrl}
  //         imgSrcSet={vehicleImageUrl}
  //         testId="personalDetailsProduct"
  //       />
  //     }
  //   >
  //     <ProductInfo
  //       title={vehicleName}
  //       captionItems={vehicleDescriptionLong}
  //       media={vehicleImageUrl ? <img alt="The product" src={vehicleImageUrl} /> : undefined}
  //     >
  //       <ProductTable title={t('shoppingCart:infoLabel')} data-theme={dataTheme ?? 'alternative'}>
  //         <ProductTable.Section>
  //           <DescriptionList split>
  //             <DescriptionList.Group termText={t('shoppingCart:customer')}>
  //               <DescriptionList.Detail>{Client}</DescriptionList.Detail>
  //             </DescriptionList.Group>
  //             <DescriptionList.Group termText={t('shoppingCart:product')}>
  //               <DescriptionList.Detail>{selectedFinancialProductData?.label}</DescriptionList.Detail>
  //             </DescriptionList.Group>
  //             <DescriptionList.Group termText={t('shoppingCart:duration')}>
  //               <DescriptionList.Detail>
  //                 {calculation?.duration} {t('shoppingCart:months')}
  //               </DescriptionList.Detail>
  //             </DescriptionList.Group>
  //             <DescriptionList.Group termText={t('shoppingCart:milage')}>
  //               <DescriptionList.Detail>
  //                 {calculation?.contractMileage} {t('shoppingCart:km')}
  //               </DescriptionList.Detail>
  //             </DescriptionList.Group>
  //           </DescriptionList>
  //           {productType === FinancialProductType.FINANCING && (
  //             <DescriptionList split>
  //               {/*   TODO: A new ticket is needed to manage this logic
  //                {financialProduct?.insuranceAndServices && (
  //                 <DescriptionList.Group
  //                   termText={t('shoppingCart:insuranceAndServices')}
  //                 >
  //                   {financialProduct.insuranceAndServices.map(
  //                     (item, index) => {
  //                       return (
  //                         // eslint-disable-next-line react/no-array-index-key
  //                         <DescriptionList.Detail key={index}>
  //                           {item?.name}
  //                         </DescriptionList.Detail>
  //                       );
  //                     }
  //                   )}
  //                 </DescriptionList.Group>
  //               )} */}
  //               {financialProduct?.firstInstallmentIsIncreased ? (
  //                 <DescriptionList.Group termText={t('shoppingCart:firstRent(insuranceAndServicesIncluded)')}>
  //                   <DescriptionList.Detail>
  //                     {formatPrice(financialProduct?.totalAmountInsAndServ) ?? 0}{' '}
  //                   </DescriptionList.Detail>
  //                 </DescriptionList.Group>
  //               ) : (
  //                 <></>
  //               )}
  //               <DescriptionList.Group termText={t('shoppingCart:rent(insuranceAndServicesIncluded)')}>
  //                 <DescriptionList.Detail>{financialProduct?.totalRate ?? formatPrice(857)}</DescriptionList.Detail>
  //               </DescriptionList.Group>
  //             </DescriptionList>
  //           )}
  //         </ProductTable.Section>
  //       </ProductTable>
  //     </ProductInfo>
  //   </FoldOut>
  // );
};

// PC-2996 Shopping Cart switched off for the whole journey
// export default connect((state: any) => ({
//   dataStorageData: getFormData(state),
// }))(ShoppingCart);

export default (() => null) as (...args: any[]) => null;
